export default __webpack_public_path__ + "static/media/logoHorizontal.56eb57b2.png";